// This file is generated by pnpm icons:generate. Do not edit.

import {ArrowOutOfBox_Stroke2_Corner0_Rounded as CanonicalArrowOutOfBox_Stroke2_Corner0_Rounded} from './Arrow'
import {ArrowOutOfBoxModified_Stroke2_Corner2_Rounded as CanonicalArrowOutOfBoxModified_Stroke2_Corner2_Rounded} from './Arrow'

/** @deprecated Import ArrowOutOfBox_Stroke2_Corner0_Rounded from `#/components/icons/Arrow` instead. */
export const ArrowOutOfBox_Stroke2_Corner0_Rounded =
  CanonicalArrowOutOfBox_Stroke2_Corner0_Rounded

/** @deprecated Import ArrowOutOfBoxModified_Stroke2_Corner2_Rounded from `#/components/icons/Arrow` instead. */
export const ArrowOutOfBoxModified_Stroke2_Corner2_Rounded =
  CanonicalArrowOutOfBoxModified_Stroke2_Corner2_Rounded
